"use client";
import { cn } from "@shared/src/utils/cn";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export function IxLogo({
  className,
  withText = true,
  priority = false,
}: {
  className?: string;
  withText?: boolean;
  priority?: boolean;
}) {
  // Hydration-safe: always render light logo on server, switch to theme after mount
  const { theme } = useTheme();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  // Fallback to light theme for SSR
  const isDark = mounted && theme === "dark";

  const logoLightUrl = "https://developers.iexchange.global/logo-light.png";
  const logoDarkUrl = "https://developers.iexchange.global/logo.png";
  const logoTextLightUrl = "https://developers.iexchange.global/logo-text-light.png";
  const logoTextDarkUrl = "https://developers.iexchange.global/logo-with-text-dark.png";

  return (
    <div className={cn("relative flex h-10 items-center overflow-hidden", className)}>
      {/* Desktop Logo - Combined or Separate based on theme */}
      <div className="hidden h-[40px] xl:flex items-center">
        {isDark ? (
          withText ? (
            <img src={logoTextDarkUrl} alt="iExchange" width={150} height={150} />
          ) : (
            <img src={logoDarkUrl} alt="iExchange" width={40} height={40} />
          )
        ) : (
          <>
            <img src={logoLightUrl} alt="iExchange" width={40} height={40} />
            {withText && <img src={logoTextLightUrl} alt="iExchange" width={110} height={40} />}
          </>
        )}
      </div>
      {/* Mobile Logo */}
      <img
        src={isDark ? logoDarkUrl : logoLightUrl}
        alt="iExchange"
        width={40}
        height={40}
        className="block xl:hidden"
      />
    </div>
  );
}
